import DataObjectField from "@/utilities/classes/data-object-field";

const buildCreateMIHTenantIncomeObject = (CurrIncome, RelatedTenant, PayStubFile, PayStubName, PayStub2File, PayStub2Name, PayStub3File, PayStub3Name, PayStub4File, PayStub4Name, ProofOfIncomeFile, ProofOfIncomeName) => {

    const fields = [
    new DataObjectField(CurrIncome.IncomeType, 7),
    new DataObjectField(CurrIncome.Income, 8),
    new DataObjectField(CurrIncome.PayFrequency, 9),
    new DataObjectField(RelatedTenant, 14),
  ];

  if(PayStubName != '') {
    fields.push(
      {
          _fid: "10",
          _filename: PayStubName,
          __text: PayStubFile,
      }
    );
  }
  if(PayStub2Name != '') {
    fields.push(
      {
          _fid: "11",
          _filename: PayStub2Name,
          __text: PayStub2File,
      }
    );
  }
  if(PayStub3Name != '') {
    fields.push(
      {
          _fid: "12",
          _filename: PayStub3Name,
          __text: PayStub3File,
      }
    );
  }
  if(PayStub4Name != '') {
    fields.push(
      {
          _fid: "13",
          _filename: PayStub4Name,
          __text: PayStub4File,
      }
    );
  }
  if(ProofOfIncomeName != '') {
    fields.push(
      {
          _fid: "10",
          _filename: ProofOfIncomeName,
          __text: ProofOfIncomeFile,
      }
    );
  }

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_MIH_TENANT_INCOME",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      field: fields
    }
  };
  return dataObject;
};

export default buildCreateMIHTenantIncomeObject;